import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-grey" }
const _hoisted_2 = {
  key: 0,
  class: "text-grey mb-0"
}
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = {
  key: 1,
  class: "text-grey text--lighten-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.modalShow)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.modalShow,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalShow) = $event)),
        width: "900",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          (_ctx.modelAccess)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { "primary-title": "" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.whoHasAccess")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_text, { class: "pt-4" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("message.whoHasAccessHint")), 1),
                      (!_ctx.users.length)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t("message.whoHasAccessNoUsers")), 1))
                        : (_openBlock(), _createBlock(_component_v_table, {
                            key: 1,
                            density: "compact",
                            class: "tbdc-accessmatrix"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t("message.whoHasAccessUser")), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                                    return (_openBlock(), _createElementBlock("th", {
                                      key: role.id,
                                      class: "text-center"
                                    }, _toDisplayString(role.name), 1))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: user.id
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass({ 'text-decoration-line-through text-grey': user.deletedFromAzureAd })
                                      }, _toDisplayString(user.title), 3),
                                      (user.deletedFromAzureAd)
                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                            key: 0,
                                            location: "bottom"
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_icon, _mergeProps({
                                                size: "small",
                                                color: "error",
                                                class: "ml-1"
                                              }, { ref_for: true }, props), {
                                                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                                  _createTextVNode("mdi-account-off-outline", -1)
                                                ]))]),
                                                _: 1
                                              }, 16)
                                            ]),
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.whoHasAccessDeleted")), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                                      return (_openBlock(), _createElementBlock("td", {
                                        key: role.id,
                                        class: "text-center"
                                      }, [
                                        (_ctx.grantingGroups(user, role.name).length)
                                          ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                              key: 0,
                                              location: "bottom"
                                            }, {
                                              activator: _withCtx(({ props }) => [
                                                _createVNode(_component_v_icon, _mergeProps({
                                                  size: "small",
                                                  color: "success"
                                                }, { ref_for: true }, props), {
                                                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                                    _createTextVNode("mdi-check", -1)
                                                  ]))]),
                                                  _: 1
                                                }, 16)
                                              ]),
                                              default: _withCtx(() => [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.whoHasAccessGrantedBy")) + ": " + _toDisplayString(_ctx.grantingGroups(user, role.name).join(', ')), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_4, "—"))
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          }))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        variant: "text",
                        onClick: _ctx.close
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.close")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}